import type { CSSProperties } from 'react';

/** An element's place in a staggered entrance: styles.css delays its animation by `--n` steps. */
export const order = (n: number) => ({ '--n': n }) as CSSProperties;
